import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import formatNum from '../../../../utils/helpers';
import { Box } from '../../../UI';

export default function Output({ data }) {
	const { equityInvested, unleveredIRR, leveredIRR, unleveredCash, leveredCash } = data;
	return (
		<Box>
			<ExpansionPanel defaultExpanded={true}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<Typography variant="h6">
						<strong>Output</strong>
					</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails>
					<TableContainer>
						<Table aria-label="simple table">
							<TableBody>
								<TableRow>
									<TableCell align="left">
										<strong>Equity Invested</strong>
									</TableCell>
									<TableCell align="right">£{formatNum(equityInvested)}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Unlevered IRR (%)</strong>
									</TableCell>
									<TableCell align="right">{unleveredIRR}%</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Levered IRR (%)</strong>
									</TableCell>
									<TableCell align="right">{leveredIRR}%</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Unlevered Cash-Multiple</strong>
									</TableCell>
									<TableCell align="right">{unleveredCash}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Levered Cash-Multiple</strong>
									</TableCell>
									<TableCell align="right">{leveredCash}</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</ExpansionPanelDetails>
			</ExpansionPanel>
		</Box>
	);
}
